export default [
  {
    path: "/dashboard",
    name: "dashboard",
    component: () => import("@/modules/dashboard/components/Dashboard"),
  },
];
